<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <navbar>
      <template v-slot:navbarname>
        <b-link class="btn btn-primary btn-round" :to="{name:'NewUser'}">+ Neu User</b-link>
      </template>
    </navbar>


    <b-card>
      <b-row>
        <b-col cols="12" md="6">
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group label="filter">
                <b-form-radio-group
                    id="role"
                    v-model="filter.value"
                    :options="filter.itemsRole"
                    @change="onSelectFilter('role')"
                    name="role"
                ></b-form-radio-group>
                <b-form-radio-group
                    id="type"
                    v-model="filter.value"
                    :options="filter.itemsType"
                    @change="onSelectFilter('userType')"
                    name="type"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group label="export">
                <b-form-select @change="onChangeFilter" v-model="filterExcel.filter"
                               :options="filterExcel.itemsSelect"></b-form-select>

                <download-excel
                    v-if="filterExcel.itemsExcel.length"
                    :name="'users'"
                    :data="filterExcel.itemsExcel">
                  <b-button variant="success">
                    <span>Export to Excel</span>
                  </b-button>
                </download-excel>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="search">
            <b-input
                v-model="searchInput"
                placeholder="Nutzername,Email"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <!--END Filter-->

    <b-card class="mt-0 sticky-top" style="z-index: 99999" v-if="filter.userIds.length > 0">
      <b-row>
        <b-col cols="12" md="3">
          <h3 class="font-weight-bold my-0">{{ $t('selectAction') }}</h3>
        </b-col>
        <b-col cols="12" md="9">
          <b-form-select
              @change="processGroup"
              v-model="processGroupType" :options="filter.itemsGroup"></b-form-select>
        </b-col>
      </b-row>
    </b-card>

    <b-card v-if="table.items.length > 0">
      <h3 class="font-weight-bold">Benutzer : <span>{{ usersCount }}</span></h3>
      <div class="table-responsive">
        <b-table :items="table.items" :fields="table.fields">

          <template v-slot:cell(select)="row">
            <b-form-checkbox
                :id="'ch'+row.item.id"
                :name="'ch'+row.item.id"
                v-model="filter.userIds"
                :value="row.item.id"
            >

            </b-form-checkbox>
          </template>

          <template v-slot:cell(action)="row">
            <b-link
                :to="{name:'UserDetails',params:{'userid':row.item.id}}"
                class="btn btn-info">{{ $t('detailsTitle') }} {{ row.id }}
            </b-link>
          </template>
        </b-table>
      </div>

      <infinite-loading :identifier="infiniteId" :distance="1" @infinite="getUsers"></infinite-loading>

    </b-card>

  </div>
</template>

<script>
import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'
import Notification from '../../Services/Notification/Nottification'

export default {
  name: "Index",
  components: {Navbar},
  data() {
    return {
      page: 1,
      processGroupType: null,
      infiniteId: +new Date(),
      searchInput: null,
      table: {
        fields: [
          {
            key: 'select',
            label: 'select'
          },
          {
            key: 'username',
            label: 'Nutzername'
          },
          {
            key: 'email',
            label: 'Email'
          },
          {
            key: 'status',
            label: 'Status'
          },
          {
            key: 'role',
            label: 'Rolle'
          },
          {
            key: 'orders',
            label: 'Anzahl der Bestellungen'
          },
          {
            key: 'date',
            label: 'Nutzername'
          },
          {
            key: 'username',
            label: 'Nutzername'
          },
          {
            key: 'action',
            label: 'action'
          },

        ],
        items: []
      },
      filter: {
        itemsGroup: [
          {
            text: 'active',
            value: 'active'
          },
          {
            text: 'pending',
            value: 'pending'
          },
          {
            text: 'change to admin',
            value: 'role_admin'
          },
          {
            text: 'change to user',
            value: 'role_user'
          },
          {
            text: 'change to SEO Manager',
            value: 'role_seo'
          },
          {
            text: 'delete',
            value: 'delete'
          },

        ],
        itemsRole: [
          {
            text: 'user',
            value: 'user'
          },
          {
            text: 'admin',
            value: 'admin'
          },
          {
            text: 'Seo Manager',
            value: 'seo_manager'
          },
          {
            text: 'Angestellter',
            value: 'order_manager'
          },
        ],
        itemsType: [
          {
            text: 'vip',
            value: 'vip'
          },
        ],
        userIds: [],
        type: null,
        value: null
      },
      filterExcel: {
        itemsSelect: [
          {
            text: 'Nicht bezahlt',
            value: 'unpaid'
          },
          {
            text: 'All Users',
            value: 'users'
          },
          {
            text: 'Storniert',
            value: 'cancel'
          },
          {
            text: 'Bestellte Daten',
            value: 'ordered'
          },
          {
            text: 'Nicht bestellt',
            value: 'notorder'
          },
          {
            text: 'Hat seit mehr als einem Monat nicht bestellt',
            value: 'notordermonth'
          },

        ],
        filter: null,
        itemsExcel: []
      },
      usersCount: 0
    }
  },
  watch: {
    searchInput(after, before) {
      this.filter.type = 'search';
      this.filter.value = this.searchInput;
      this.onSelectFilterProcess();
    }
  },
  methods: {
    onChangeFilter() {
      this.filterUsersExcel();
    },
    onSelectFilter(myValue) {
      this.filter.type = myValue;
      this.onSelectFilterProcess();
    },
    onSelectFilterProcess() {
      this.page = 1;
      this.table.items = [];
      this.infiniteId += 1;
      this.getUsers();
    },
    getUsers($state) {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'user/index?page=' + this.page, {
        type: this.filter.type,
        filterValue: this.filter.value,
        search: this.searchInput,
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              if (response.data.data.users.length > 0) {
                this.page += 1;
                this.table.items.push(...response.data.data.users);
                this.usersCount = response.data.data.usersCount;
                $state.loaded();
              } else {
                $state.complete();
              }
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    processGroup() {
      if (confirm(this.$t('alertText'))) {
        this.$Progress.start();
        Http.post(Http.apiurlV2() + 'user/process/group', {
          userIds: this.filter.userIds,
          type: this.processGroupType
        })
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.onSelectFilterProcess();
                this.filter.userIds = [];
                Notification.success(response.data.message)
              } else {
                Notification.error(response.data.message)

              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
    filterUsersExcel() {
      this.$Progress.start();
      Http.get(Http.apiurlV2() + 'user/export/' + this.filterExcel.filter)
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.filterExcel.itemsExcel = response.data.data;
            } else {
              Notification.error(response.data.message)
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
  },
  created() {
    this.getUsers();
  }
}
</script>

<style scoped>

</style>